import React from "react";
import Link from "react-router-dom/Link";
import "../../../public/styles/blog/blogHomepage.scss";

function BlogHeader(props) {
  return (
    <div className="blog-navigation">
      <ul className="blog-logo">
        <li className="list-items logo">
          {props.homeImages &&
            props.homeImages.homePageLogo &&
            props.homeImages.homePageLogo.thumbnail && (
            <a href="\blog">
              <img src={props.homeImages.homePageLogo.thumbnail} alt="" />
            </a>
          )}
        </li>
      </ul>

      <div>
        <ul className="category-list">
          {!!props.categoryNameList &&
            props.categoryNameList.map((categoryName, index) => (
              <li
                className="list-items"
                key={`category-${index}`}
                id={categoryName + index}
              >
                <Link
                  to={`/blog/${categoryName
                    .replaceAll(" ", "-")
                    .toLowerCase()}`}
                  className="action-nav"
                >
                  {`${categoryName.toUpperCase()}`}
                </Link>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default BlogHeader;
